<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <SearchBar></SearchBar>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <ais-instant-search :search-client="searchClient" index-name="Product">
          <div class="card card-custom gutter-b card-stretch">
            <ais-refinement-list
              attribute="searchable_industries_names"
              searchable
            />
            <ais-refinement-list
              attribute="searchable_location_names"
              searchable
            />

            <ais-search-box placeholder="Search here…" class="searchbox" />
            <ais-hits>
              <template slot="item" slot-scope="{ item }">
                <div class="card card-custom card-stretch gutter-b">
                  <!--begin::Body-->
                  <div class="card-body d-flex flex-column">
                    <div class="flex-grow-2 pb-6">
                      <!--begin::Info-->
                      <div class="d-flex align-items-center pr-2 mb-6">
                        <span
                          class="text-muted font-weight-bold font-size-lg flex-grow-1"
                          >7 Hours Ago</span
                        >
                        <div class="symbol symbol-50">
                          <span class="symbol-label bg-light-light">
                            <img
                              src="media/svg/misc/006-plurk.svg"
                              class="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                      </div>
                      <!--end::Info-->
                      <!--begin::Link-->
                      <a
                        href="#"
                        class="text-dark font-weight-bolder text-hover-primary font-size-h4"
                        ><ais-highlight :hit="item" attribute="title"
                      /></a>
                      <!--end::Link-->
                      <!--begin::Desc-->
                      <p
                        class="text-dark-50 font-weight-normal font-size-lg mt-6 rows-4"
                      >
                        <ais-highlight :hit="item" attribute="description" />
                      </p>
                      <!--end::Desc-->
                    </div>
                    <!--begin::Team-->
                    <div class="d-flex align-items-center">
                      <!--begin::Pic-->
                      <p>
                        Locations
                        <a href="#" class="symbol symbol-45 symbol-light">
                          <b-badge
                            :key="index"
                            v-for="(val,
                            index) in item.searchable_locations_names"
                            class="mr-1"
                            variant="secondary"
                            ><ais-highlight
                              :hit="item"
                              :attribute="'searchable_locations_names.' + index"
                          /></b-badge>
                        </a>
                      </p>
                    </div>
                    <!--                    <div class="d-flex align-items-center">-->
                    <!--                      <p v-if="item.searchable_industries_names[0]">-->
                    <!--                        Industries-->
                    <!--                        <a href="#" class="symbol symbol-45 symbol-light">-->
                    <!--                          <b-badge-->
                    <!--                            :key="index"-->
                    <!--                            v-for="(val,-->
                    <!--                            index) in item.searchable_industries_names"-->
                    <!--                            class="mr-1"-->
                    <!--                            variant="primary"-->
                    <!--                            ><ais-highlight-->
                    <!--                              :hit="item"-->
                    <!--                              :attribute="-->
                    <!--                                'searchable_industries_names.' + index-->
                    <!--                              "-->
                    <!--                          /></b-badge>-->
                    <!--                        </a>-->
                    <!--                      </p>-->
                    <!--                      <b-field label="Enter some tags">-->
                    <!--                        <b-taginput-->
                    <!--                          v-model="tags"-->
                    <!--                          :data="filteredTags"-->
                    <!--                          autocomplete-->
                    <!--                          field="user.first_name"-->
                    <!--                          icon="label"-->
                    <!--                          placeholder="Add a tag"-->
                    <!--                          @typing="getFilteredTags"-->
                    <!--                        >-->
                    <!--                          <template slot-scope="props">-->
                    <!--                            <strong>{{ props.option.id }}</strong-->
                    <!--                            >: {{ props.option.canonical_name }}-->
                    <!--                          </template>-->
                    <!--                          <template slot="empty">-->
                    <!--                            There are no items-->
                    <!--                          </template>-->
                    <!--                        </b-taginput>-->
                    <!--                      </b-field>-->
                    <!--                    </div>-->
                    <!--end::Pic-->
                    <!--begin::Pic-->
                    <!--                      <a href="#" class="symbol symbol-45 symbol-light mr-3">-->
                    <!--                        <div class="symbol-label">-->
                    <!--                          <img-->
                    <!--                            src="media/svg/avatars/028-girl-16.svg"-->
                    <!--                            class="h-75 align-self-end"-->
                    <!--                            alt=""-->
                    <!--                          />-->
                    <!--                        </div>-->
                    <!--                      </a>-->
                    <!--                      &lt;!&ndash;end::Pic&ndash;&gt;-->
                    <!--                      &lt;!&ndash;begin::Pic&ndash;&gt;-->
                    <!--                      <a href="#" class="symbol symbol-45 symbol-light">-->
                    <!--                        <div class="symbol-label">-->
                    <!--                          <img-->
                    <!--                            src="media/svg/avatars/024-boy-9.svg"-->
                    <!--                            class="h-75 align-self-end"-->
                    <!--                            alt=""-->
                    <!--                          />-->
                    <!--                        </div>-->
                    <!--                      </a>-->
                    <!--end::Pic-->
                    <!--end::Team-->
                  </div>
                  <!--end::Body-->
                </div>
              </template>
            </ais-hits>

            <div class="pagination">
              <ais-pagination />
            </div>
          </div>
        </ais-instant-search>
      </div>
    </div>
    <div class="row">
      <Widget2></Widget2>
      <div class="col-xl-12">
        <ListWidget5></ListWidget5>
      </div>
    </div>
    <!--      <div class="col-xl-4">-->
    <!--        <ListWidget3></ListWidget3>-->
    <!--      </div>-->
    <!--      <div class="col-xl-4">-->
    <!--        <ListWidget10></ListWidget10>-->
    <!--      </div>-->
    <!--      <div class="col-xl-4">-->
    <!--        <ListWidget4></ListWidget4>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--end::Row-->
    <div class="row">
      <div class="col-xl-4">
        <ListWidget11></ListWidget11>
      </div>
      <div class="col-xl-4">
        <ListWidget12></ListWidget12>
      </div>
      <div class="col-xl-4">
        <ListWidget13></ListWidget13>
      </div>
    </div>
    <!--end::Row-->
    <!--begin::Row-->
    <div class="row">
      <div class="col-lg-4">
        <ListWidget8></ListWidget8>
      </div>
      <div class="col-lg-8">
        <ListWidget2></ListWidget2>
      </div>
    </div>
    <!--end::Row-->
    <!--end::Dashboard-->
  </div>
</template>

<script>
import "instantsearch.css/themes/algolia-min.css";
import algoliasearch from "algoliasearch/lite";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ListWidget2 from "@/view/content/widgets/list/Widget2.vue";
import ListWidget5 from "@/view/content/widgets/list/Widget5.vue";
import ListWidget8 from "@/view/content/widgets/list/Widget8.vue";
import ListWidget11 from "@/view/content/widgets/list/Widget11.vue";
import ListWidget12 from "@/view/content/widgets/list/Widget12.vue";
import ListWidget13 from "@/view/content/widgets/list/Widget13.vue";
import Widget2 from "@/view/content/widgets/advance-table/Widget2";
import SearchBar from "@/view/pages/search/algolia-search/SearchBar";
import { HapiService } from "@/core/services/hapi.service";

export default {
  name: "dashboard",
  components: {
    SearchBar,
    Widget2,
    ListWidget2,
    ListWidget5,
    ListWidget8,
    ListWidget11,
    ListWidget12,
    ListWidget13
  },
  data() {
    return {
      tags: ["a", "b"],
      filteredTags: [],
      searchClient: algoliasearch(
        "OWF766BMHV",
        "7e2e8345947ed95b8bdb4dba05094126"
      )
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  methods: {
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
    async getFilteredTags(text) {
      const results = await HapiService.apiService.get("/locations/", {
        text
      });

      return results;
    }
  }
};
</script>
<style>
.rows-4 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
